export namespace EnumUtils {

    export function keys<T>(list: T): (keyof T)[] {
        return Object.keys(list as Object).filter(k => !(parseInt(k) >= 0)) as any;
    }
    export function values<T>(list: T): any[] {
        return keys(list).map(k => list[k]);
    }
}
export namespace Route {
    export function searchParam(key: string):string {
        const query = window.location.search.substring(1);
        const params = query.split("&");
        for (var i = 0; i < params.length; i++) {
            var pair = params[i].split("=");
            if (pair[0] === key) {
                return pair[1];
            }
        }
        return '';
    }
}
export namespace Strings {
    export function plural(value: number, words: string[]): string {
        value = Math.abs(value) % 100;
        const num = value % 10;
        if (value > 10 && value < 20) {
            return words[2];
        }
        if (num > 1 && num < 5) {
            return words[1];
        }
        if (num == 1) {
            return words[0];
        }
        return words[2];
    }

    export function userNameSlug(name: string, rating: number, highScore: number) {
        let maxLength: number;
        const scoreLength = highScore.toString().length;

        if (rating < 4) {
            maxLength = 20 - scoreLength;
        } else {
            maxLength = 21 - scoreLength;
        }

        return name.length > maxLength
            ? name.slice(0, maxLength - 3) + '...'
            : name;
    }
}

export function promiseTimeout(ms: number) {
    let timeout = new Promise((resolve, reject) => {
        let id = setTimeout(() => {
            clearTimeout(id);
            reject('Timed out')
        }, ms)
    })

    return timeout;
}

export function getCookie(){
    return document.cookie.split('; ').reduce((prev, current) => {
        const [name, ...value] = current.split('=');
        prev[name] = value.join('=');
        return prev;
    }, {});
}

export function clipboard (text){
    return navigator.clipboard.writeText(text)
        .then(() => {
            console.log(text);
        })
        .catch(err => {
            console.log('Something went wrong', err);
        });
}
